module.exports = __webpack_public_path__ + "static/img/preview-mobile.54f3761.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/work/land-rover/preview-mobile.jpg
// module id = QbIR
// module chunks = 1